export default {
  reason: {
    type: 'enum',
    required: true,
  },
};
